import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Config from './index';

export default () => {
  return (
    <BrowserRouter>
        {
              Config.map((item:any,index:number)=>{
                return (
                    <Route
                        key={index}
                        exact
                        path={item.path}
                        component={item.component}
                    ></Route>
                )
              })
        }
    </BrowserRouter>
  );
};
